import { safeInternalPath } from './safeInternalPath';

const KIND_LABEL = {
  license: 'Licença',
  process: 'Processo',
  complaint: 'Denúncia',
  condicionante: 'Condicionante',
  enterprise: 'Empreendimento',
};

const KIND_CTA = {
  license: 'Abrir licença',
  process: 'Abrir processo',
  complaint: 'Abrir denúncia',
  condicionante: 'Abrir licença',
  enterprise: 'Abrir cadastro',
};

export function kindLabel(kind) {
  return KIND_LABEL[kind] || 'Registro';
}

export function normalizeEntities(entities) {
  return (entities || [])
    .map((item) => {
      const href = safeInternalPath(item?.href);
      if (!href) return null;
      const kind = String(item.kind || '').trim();
      return {
        kind,
        id: item.id,
        title: item.title || kindLabel(kind),
        status: item.status || '',
        meta: item.meta || '',
        href,
        cta: item.cta || KIND_CTA[kind] || 'Abrir',
      };
    })
    .filter(Boolean);
}

export function splitAssistantText(text) {
  const raw = String(text || '').trim();
  if (!raw) return { heading: '', body: '' };
  const lines = raw.split('\n');
  const first = lines[0].trim();
  const looksLikeHeading = first.endsWith(':') || /\(\d+\)\s*$/.test(first);
  if (looksLikeHeading && lines.length > 1) {
    return { heading: first.replace(/:$/, ''), body: lines.slice(1).join('\n').trim() };
  }
  return { heading: '', body: raw };
}
